<template>
  <div>
    <v-flex xs12 class="primary pl-1">
      <v-img
        class="align-top white--text px-10 pt-10"
        src="@/assets/images/Header-Background-bottom_.png"
        height="212px"
      >
        <h2 class="fs-22 pr-5 mb-5">
          Welcome to Help Center, how can we help you?
        </h2>
        <v-flex xs8>
          <v-text-field
            height="40px"
            solo
            rounded
            placeholder="Search for answer..."
            prepend-inner-icon="search"
          ></v-text-field>
        </v-flex>
      </v-img>
    </v-flex>
  </div>
</template>

<script>
export default {};
</script>
<style>
.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
  padding: 0px !important;
}
.v-text-field--rounded > .v-input__control > .v-input__slot {
  padding: 0 16px !important;
  background: #fff;
  min-height: 35px !important;
}
</style>
